import type { Router } from '@angular/router';
import type { ShipmentFlowStateService } from '../../../core/services/shipment-flow-state.service';

/**
 * When an active completed shipment exists, sends the customer back to Get Labels
 * so earlier wizard steps cannot be re-entered.
 *
 * @returns true when a redirect was initiated
 */
export function redirectIfCompletedShipmentActive(
  flowState: ShipmentFlowStateService,
  router: Router,
): boolean {
  if (!flowState.hasActiveCompletedShipment()) {
    return false;
  }

  router.navigateByUrl('/get-labels').catch(() => undefined);
  return true;
}
